import Card from "components/card";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineMoreTime } from "react-icons/md";
import { BsCalendar3 } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/loader";
import { Alert } from "@chakra-ui/react";
import { fetchScheduleList } from "services/schedule/kindergartenScheduleSlice";
const KindergartenSchedule = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const kindergartenSchedule = useSelector((state) => {
    return state.kindergartenSchedule;
  });
  const columnsData = [
    "№",
    "Нэр",
    "Ээлж",
    "Эхлэх огноо",
    "Дуусах огноо",
    "Хуваарь зохиох",
  ];
  useEffect(() => {
    dispatch(fetchScheduleList());
  }, [dispatch]);

  return (
    <Card extra={"w-full h-full p-4  mt-4"}>
      <div className="relative mb-4 flex items-center justify-end">
        <button
          onClick={() => {
            navigate("/admin/kindergarten_daily_detail", {
              state: { type: "register" },
            });
          }}
          className={`flex items-center text-xl hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
        >
          <MdOutlineMoreTime className="h-6 w-6" />
        </button>
      </div>

      <div className="h-full overflow-x-scroll xl:overflow-hidden">
        {kindergartenSchedule.loading && <Loader />}
        {!kindergartenSchedule.loading && kindergartenSchedule.error ? (
          <Alert text={kindergartenSchedule.error} />
        ) : null}
        {!kindergartenSchedule.loading &&
        kindergartenSchedule.scheduleList.length ? (
          <table className="responsive_table" mb="24px">
            <thead>
              <tr key={"sch-header"}>
                {columnsData.map((column, index) => (
                  <th key={"user-header" + index}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {kindergartenSchedule.scheduleList.map((row, i) => {
                return (
                  <tr key={i}>
                    <td data-label="№">{i + 1}</td>
                    <td data-label="Нэр">
                      <button
                        onClick={() => {
                          navigate(
                            "/admin/kindergarten_daily_detail/" + row.id
                          );
                        }}
                        className="text-blue-800 underline hover:text-blue-600 dark:text-white "
                      >
                        {row.name}
                      </button>
                    </td>
                    <td data-label="Ээлж">{row.shift.name}</td>
                    <td data-label="Эхлэх огноо">{row.start ?? "-"}</td>
                    <td data-label="Дуусах огноо">{row.end ?? "-"}</td>
                    <td data-label="Хуваарь зохиох">
                      {" "}
                      <BsCalendar3
                        className="inline-block h-6 w-6 cursor-pointer fill-activeOrange"
                        onClick={() => {
                          navigate("/admin/kindergarten_daily_add/" + row.id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
      </div>
    </Card>
  );
};

export default KindergartenSchedule;
